/*=====================================================================*\
   @new
   - Section takes inspiration from `image-with-text-overlay.js`
\*=====================================================================*/

/**
 *  @class
 *  @function WrDualImages
 */

if (!customElements.get('wr-dual-images')) {
  class WrDualImages extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }
    connectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }
    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.tl.kill();
        this.splittext.revert();
      }
    }
    prepareAnimations() {
      let section = this,
        button_offset = 0,
        property = (gsap.getProperty("html", "--header-height") + gsap.getProperty("html", "--header-offset")) + 'px';

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top center"
        }
      });

      document.fonts.ready.then(function () {
        const headings = section.querySelectorAll('.wr-dual-images--heading');
        let allSplitTexts = [];

        headings.forEach((headingEl) => {
          let split = new SplitText(headingEl, {
            type: 'lines, words',
            linesClass: 'line-child'
          });
          allSplitTexts.push(split);

          let h3_duration = 0.8 + ((headingEl.querySelectorAll('.line-child div').length - 1) * 0.05);

          section.tl
            .set(headingEl, {
              visibility: 'visible'
            }, 0)
            .from(headingEl.querySelectorAll('.line-child div'), {
              duration: h3_duration,
              yPercent: '100',
              stagger: 0.05
            }, 0);

          button_offset += h3_duration;
        });

        section.splittext = {
          revert: () => allSplitTexts.forEach(s => s.revert())
        };

        if (section.querySelector('.subheading')) {
          section.tl
            .fromTo(section.querySelector('.subheading'), {
              opacity: 0
            }, {
              duration: 0.75,
              opacity: 1
            }, 0);

          button_offset += 0.5;
        }

        if (section.querySelector('.rte p')) {
          let p_duration = 0.8 + ((section.querySelectorAll('.rte p .line-child div').length - 1) * 0.02);
          section.tl
            .set(section.querySelectorAll('.rte p'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('.rte p .line-child div'), {
              duration: p_duration,
              yPercent: '100',
              stagger: 0.02
            }, 0);

          button_offset += p_duration;
        }

        if (section.querySelectorAll('.button')) {
          let i = 1;
          section.querySelectorAll('.button').forEach((item) => {
            section.tl.fromTo(item, {
              autoAlpha: 0
            }, {
              duration: 0.5,
              autoAlpha: 1
            }, ((button_offset * 0.4) + (i - 1) * 0.1));
            i++;
          });
        }

      });
    }
  }
  customElements.define('wr-dual-images', WrDualImages);
}